import { useEffect, useState } from 'react'
import { createContainer } from 'unstated-next'
import { isMobile as isMobileFunc } from '../utils'

interface useSystemProps {
  isMobile: boolean
}

function useSystem(): useSystemProps {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        setWindowWidth(window.innerWidth)
      },
      false
    )
  }, [])

  useEffect(() => {
    setIsMobile(isMobileFunc(windowWidth))
  }, [windowWidth])

  return {
    isMobile,
  }
}
const System = createContainer(useSystem)

export default System
